import React from 'react';

const formatProjectedCurrency = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? `$${numericValue.toFixed(2)}` : '';
};

const TradeCalculations = ({
  lotSize,
  projectedLoss,
  projectedProfit,
  profitTarget,
  stopLossPrice,
  stopLossDistance,
}) => {
  return (
    <div className="space-y-1.5 text-[10px]">
      <div className="grid grid-cols-3 gap-x-3 gap-y-2">
        <div className="min-w-0 space-y-0.5">
          <p className="trade-panel-stat-label font-medium text-textSecondary">Lot Size</p>
          <p className="font-mono text-sm font-semibold text-textPrimary">{lotSize}</p>
        </div>
        <div className="min-w-0 space-y-0.5">
          <p className="trade-panel-stat-label font-medium text-textSecondary">SL</p>
          <p className="font-mono text-sm font-semibold text-textPrimary">{stopLossPrice}</p>
        </div>
        <div className="min-w-0 space-y-0.5">
          <p className="trade-panel-stat-label font-medium text-textSecondary">TP</p>
          <p className="font-mono text-sm font-semibold text-textPrimary">{profitTarget}</p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-x-3 gap-y-2 border-t border-borderDefault/20 pt-2">
        <div className="space-y-0.5">
          <p className="trade-panel-stat-label font-medium text-textSecondary">Loss</p>
          <p className="font-mono text-sm font-semibold text-destructive">
            {formatProjectedCurrency(projectedLoss)}
          </p>
        </div>
        <div className="space-y-0.5">
          <p className="trade-panel-stat-label font-medium text-textSecondary">Profit</p>
          <p className="font-mono text-sm font-semibold text-success">
            {formatProjectedCurrency(projectedProfit)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TradeCalculations;
